module.exports = __webpack_public_path__ + "static/img/case_detail_04_3.0f898ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_04_3.png
// module id = B6wM
// module chunks = 34